import React from 'react';
import {
  StyledWrapper,
  StyledImage,
  ImagesContainer,
  ImageLink,
  VideoThumbnail
} from './style';
import hoop from '../../../../assets/images/png/hoop_v1.png';
import hoopVisita1 from '../../../../assets/images/png/hoop_visita_02_01.png';
import hoopVisita2 from '../../../../assets/images/png/hoop_visita_02_02.png';

const video1Url =
  'https://www.atresmedia.com/newsletter/responsabilidad-corporativa/sostenibilidad/atresmedia-hoop4/videos/viaje.mp4';
const video2Url =
  'https://www.atresmedia.com/newsletter/responsabilidad-corporativa/sostenibilidad/atresmedia-hoop4/videos/match.mp4';

const Hoop = () => (
  <StyledWrapper>
    <StyledImage src={hoop} />
    <ImagesContainer>
      <ImageLink href={video1Url} target="_blank" rel="noopener noreferrer">
        <VideoThumbnail src={hoopVisita1} alt="Video tutorial 1" />
      </ImageLink>
      <ImageLink href={video2Url} target="_blank" rel="noopener noreferrer">
        <VideoThumbnail src={hoopVisita2} alt="Video tutorial 2" />
      </ImageLink>
    </ImagesContainer>
  </StyledWrapper>
);

export default Hoop;
